import { useAction, useAtom } from '@reatom/npm-react'
import { format } from 'date-fns'
import { useEffect, useMemo } from 'react'

import { AsyncStateN } from '@blade/std-lib'
import { removeSessionReatom } from '@root/features/auth/session-management/atoms'
import { DATE_FORMAT } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { ConfirmDrawer } from '@root/shared/ui-kit'

import type { Session } from '@root/entities/auth'
import type { DrawerControlProps } from '@root/shared/ui-kit'

type DeleteSessionDrawerProps = {
  session: Session.Session
} & DrawerControlProps

export const DeleteSessionDrawer: React.FC<DeleteSessionDrawerProps> = ({
  open,
  onOpenChange,
  session,
}) => {
  const { t } = useTranslation()

  const { removeRequestStateAtom, removeSessionAction } = useMemo(
    () => removeSessionReatom(session.ip),
    [session.ip],
  )

  const [requestState] = useAtom(removeRequestStateAtom)
  const removeSession = useAction(removeSessionAction)

  useEffect(() => {
    if (AsyncStateN.isSuccess(requestState)) {
      onOpenChange?.(false)
    }
  }, [onOpenChange, requestState])

  return (
    <ConfirmDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={t('session.delete-confirmation')}
      description={format(session.lastLogin, DATE_FORMAT.dd_MM_yy__HH_mm)}
      intent="error"
      busy={requestState.loading}
      onConfirm={() => removeSession()}
      onCancel={() => onOpenChange?.(false)}
    />
  )
}
